<div class="mt-4 grid grid-cols-1 lg:grid-cols-2 lg:gap-4">
  <div class="_g-detail-wrapper _g-border-dashed">
    <div class="_wrapper">
      <span class="_left">{{ "paymentMethod" | translate }}</span>
      <span>{{ purchaseData.paidBy ? pidByEnumText[purchaseData.paidBy] : "-" }}</span>
    </div>

    @if (purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType !== paidBankTypeEnum.Promptpay) {
      @if (purchaseData.paidBy === paidByEnum.Bank) {
        <div class="_wrapper">
          <span class="_left">{{ "purchaseDetailList.paidBankType" | translate }} </span>
          <span>{{ paidBankTypeEnumText[purchaseData.paidBankType] }}</span>
        </div>
      }

      <div class="_wrapper">
        <span class="_left">{{ "bank" | translate }} </span>
        <span>
          @if (purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.CustomAccount) {
            {{ !purchaseData.paidToBankId ? "-" : (purchaseData.paidToBankId.translations | translations: "name") }}
          } @else if (purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.SavedAccount) {
            {{ bankData.translations | translations: "name" }}
          } @else {
            -
          }
        </span>
      </div>

      <div class="_wrapper">
        <span class="_left">{{ "branch" | translate }} </span>
        <span>
          @if (purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.CustomAccount) {
            {{ purchaseData.paidToBankBranchName ? purchaseData.paidToBankBranchName : "-" }}
          } @else if (purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.SavedAccount) {
            {{ purchaseData.paidToMemberBankId ? purchaseData.paidToMemberBankId.bankBranchName : "-" }}
          } @else {
            -
          }
        </span>
      </div>

      <div class="_wrapper">
        <span class="_left">{{ "accountNumber" | translate }} </span>
        <span>
          @if (purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.CustomAccount) {
            {{ purchaseData.paidToBankAccountNo }}
          } @else if (purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.SavedAccount) {
            {{ purchaseData.paidToMemberBankId ? purchaseData.paidToMemberBankId.bankAccountNo : "-" }}
          } @else {
            -
          }
        </span>
      </div>
    }

    @if (purchaseData.paidBy === paidByEnum.Bank && purchaseData.paidBankType === paidBankTypeEnum.Promptpay) {
      <div class="_wrapper">
        <span class="_left">{{ "purchaseDetailList.promptpay" | translate }}: </span>
        <span>{{ purchaseData.paidToPromptpay ? purchaseData.paidToPromptpay : "-" }}</span>
      </div>
    }

    <p-button
      label="ตรวจสอบลายเซ็น"
      [link]="true"
      (click)="signatureImageUrlModal.open()"
      styleClass="p-0"
    />
  </div>

  @if (purchaseData.paidSlipImageUrl) {
    <div class="_g-detail-wrapper">
      <div class="_wrapper">
        <span class="_left">{{ "slipImage" | translate }}: </span>
        <span
          ><img
            [src]="purchaseData.paidSlipImageUrl"
            class="_paidslip-image mb-4"
            imageFallback
        /></span>
      </div>
    </div>
  }
</div>

<lib-modal
  #signatureImageUrlModal
  [title]="'ลายเซ็น'"
  modalSize="lg"
>
  <div class="grid gap-x-4 sm:grid-cols-1 md:grid-cols-2">
    <div class="_g-border-dashed">
      <span class="w-1/4 font-semibold">ลายเซ็นรับซื้อ: </span>
      <img
        [src]="purchaseData.signatureImageUrl"
        class="_paidslip-image mb-4"
        imageFallback
      />
    </div>
    <div>
      <span class="w-1/4 font-semibold">ลายเซ็นสมัครสมาชิก: </span>
      @if (purchaseData.member) {
        <img
          [src]="purchaseData.member.signatureImageUrl"
          class="_paidslip-image mb-4"
          imageFallback
        />
      }
    </div>
  </div>
</lib-modal>
